import { TCreateDocumentTemplateParams } from '@commenda/types/src/document-generation';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export async function createDocumentTemplate(
  data: TCreateDocumentTemplateParams
): Promise<{
  success: boolean;
  data?: { documentTemplate: { id: string } };
}> {
  try {
    const res = await fetcher(`${BASE_URL}`, {
      method: 'POST',
      body: data,
    });
    if (!res.ok) return { success: false, data: undefined };
    const responseData = (await res.json()) as {
      documentTemplate: { id: string };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
